import React, { Component } from 'react';
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom';

import { appBackHide, 
         appBackShow,
         appSetBackPage,
         dialogClose,
         dialogOpen,
         orderDelivComplete,
         orderDelivCancel } from '../../store/actions';

import Orders from '../../components/Orders'

class Corders extends Component {
    constructor(props){
        super(props);

        this._orderCancel = this._orderCancel.bind(this);
        this._orderDone = this._orderDone.bind(this);
        this._orderReq = this._orderReq.bind(this);
    }

    componentDidMount(){
        this.props.appSetBackPage('deliv');
        this.props.appBackShow();
    }

    componentWillUnmount(){
        this.props.appBackHide();
    }

    _orderCancel() {
        this.props.orderDelivCancel(this.props.dialogPayload[0]);
        this.props.dialogClose();
    }

    _orderDone() {
        this.props.orderDelivComplete(this.props.dialogPayload[0]);
        this.props.dialogClose();
    }

    _orderReq(data){
        if (data.action === 0){
            let delivToGo = 0;

            this.props.orders.forEach(i=>{
                if (i._status===0){ delivToGo++; }
            });

            let _body = this.props.txt_confDeliv;
            
            if (data.status === 0 && delivToGo === 1){
                _body = this.props.txt_confFinalDeliv;
                _body = _body.replace("\n","<br>");
            }

            if (data.status === 0){
                this.props.dialogOpen({
                    header: this.props.txt_confirm,
                    body: _body,
                    btn1: this._orderDone,
                    btn1Txt: this.props.txt_yes,
                    btn2: this.props.dialogClose,
                    btn2Txt: this.props.txt_no,
                    payload: [data]
                });    
            }
    
            if (data.status === 1){
                this.props.dialogOpen({
                    header: this.props.txt_confirm,
                    body: this.props.txt_cdeliv + '?',
                    btn1: this._orderCancel,
                    btn1Txt: this.props.txt_yes,
                    btn2: this.props.dialogClose,
                    btn2Txt: this.props.txt_no,
                    payload: [data]
                });
            }    
        }

        if (data.action === 1){
            if (data.status===0){
                this.props.orderDelivCancel(data);
            } else {
                this.props.orderDelivComplete(data);
            }
        }
    }

    render() {
        return (
            <div>
                {<Orders
                    delivery={this.props.ordersDeliv}
                    onClick = {this._orderReq}
                    orders={this.props.orders}

                    texts={{
                        address: this.props.txt_address,
                        boar: this.props.txt_boar,
                        cdeliv: this.props.txt_cdeliv,
                        customer: this.props.txt_customer,
                        deliv: this.props.txt_deliv,
                        delivery: this.props.txt_delivery,
                        ddone: this.props.txt_ddone,
                        note: this.props.txt_note,
                        order: this.props.txt_order,
                        orders: this.props.txt_orders,
                        progress: this.props.txt_progress,
                        status: this.props.txt_status
                    }}
                />
                }
            </div>
        );
    }
}

const mapStateToProps = state => {
    const getText = (id) => {
        let text = '';
        try {
            text = state.app.texts[id][state.app.language];
        } catch (err) {
            text = '';
        }
        return text;
    }

    return {
        deliveries: state.deliveries.deliveries, 
        dialogPayload: state.msgDialog.dialogPayload,
        orders: state.orders.orders,
        ordersDeliv: state.orders.ordersDeliv,
        ordersState: state.orders.ordersState,

        txt_address: getText("0024"),
        txt_boar: getText("0018"),
        txt_customer: getText("0023"),
        txt_cdeliv: getText("0026"),
        txt_confDeliv: getText("0034"),
        txt_confFinalDeliv: getText("0047"),
        txt_confirm: getText("0030"),
        txt_deliv: getText("0025"),
        txt_delivery: getText("0029"),
        txt_ddone: getText("0046"),
        txt_note: getText("0043"),
        txt_no: getText("0032"),
        txt_order: getText("0041"),
        txt_orders: getText("0042"),
        txt_progress: getText("0027"),
        txt_status: getText("0028"),
        txt_yes: getText("0031")
    }
}

const mapDispatchToProps = dispatch => {
    return {
        appBackHide: () => dispatch(appBackHide()),
        appBackShow: () => dispatch(appBackShow()),
        appSetBackPage: (data) => dispatch(appSetBackPage(data)),
        dialogClose: () => dispatch(dialogClose()),
        dialogOpen: (data) => dispatch(dialogOpen(data)),
        orderDelivComplete: (data) => dispatch(orderDelivComplete(data)),
        orderDelivCancel: (data) => dispatch(orderDelivCancel(data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Corders));



// WEBPACK FOOTER //
// ./src/containers/Corders/index.js